import React from "react";
import styles from "./Spliter.module.scss";
import mu7Logo from "../../../assets/images/Mu7.png";
import Image from "next/future/image";
import { Col, Container, Row } from "react-bootstrap";
import { useRouter } from "next/router";
import { buildApiUrl } from "src/helpers/imageHelpers";

export default function Spliter({
  primaryTitle,
  primaryText,
  secondaryTitle,
  secondaryText,
  image,
  primaryHtml,
  secondaryHtml,
}) {
  const { locale } = useRouter();
  const normalizeValue = (value) =>
    typeof value === "string" ? value.replace(/`/g, "").trim() : "";
  const resolvedImage = normalizeValue(image);
  const imageSrc = resolvedImage ? buildApiUrl(resolvedImage) : mu7Logo;

  return (
    <div className={styles.wrapper} dir={locale === "ar" ? "rtl" : "ltr"}>
      <Container>
        <Row className={"justify-content-between align-items-end gap-2 gap-md-3"}>
          <Col xs={12} lg={5}>
            <div className={styles.column}>
              <div className={styles.titleBox}>
                <h3 className={styles.title}>{primaryTitle}</h3>
              </div>
              {primaryHtml ? (
                <div
                  className={styles.bodyText}
                  dangerouslySetInnerHTML={{ __html: primaryHtml }}
                />
              ) : (
                <p className={styles.bodyText}>{primaryText}</p>
              )}

              <div className={styles.logoWrapper}>
                <Image
                  src={imageSrc}
                  alt={primaryTitle || "MU7"}
                  width={450}
                  height={240}
                  priority={true}
                  sizes="100%"
                />
              </div>
            </div>
          </Col>

          <Col xs={12} lg={5}>
            <div className={styles.column}>
              <div className={styles.titleBox2}>
                <h3 className={styles.title}>{secondaryTitle}</h3>
              </div>
              {secondaryHtml ? (
                <div
                  className={styles.bodyText}
                  dangerouslySetInnerHTML={{ __html: secondaryHtml }}
                />
              ) : (
                <p className={styles.bodyText}>{secondaryText}</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
